module.exports = __webpack_public_path__ + "img/kids-forest-fade-sm-2x.80ce85e6.jpg";